'use client';

import { FC } from 'react';

import classNames from 'classnames';

import { useControlledValue } from '../../../../hooks/useControlledValue/useControlledValue';

interface Props {
   numberOfSteps: number;
   currentStep?: number;
   defaultStep?: number;
   readOnly?: boolean;
   variant?: 'default' | 'on-primary';
   onStepChange?: (step: number) => void;
}

export const DotsStepper: FC<Props> = ({ numberOfSteps, currentStep: currentStepFromProps, defaultStep, readOnly = false, variant = 'default', onStepChange }) => {
   const [currentStep, setCurrentStep] = useControlledValue(currentStepFromProps, onStepChange, defaultStep || 0);

   const handleStepChange = (newStep: number) => {
      if (readOnly || currentStep === newStep) return;

      setCurrentStep(newStep);
   };

   return (
      <div data-testid="dots-stepper" className="gap-component-navigation-dot-stepper-container-spacing-gap flex justify-center" role="tablist" aria-label="Stepper navigation">
         {Array.from({ length: numberOfSteps }, (_, i) => i).map((step) => (
            <button
               key={step}
               type="button"
               aria-label={`Go to step ${step + 1}`}
               role="tab"
               aria-selected={currentStep === step}
               tabIndex={currentStep === step ? 0 : -1}
               aria-current={currentStep === step ? 'step' : undefined}
               data-testid={`dots-stepper-step--${step}`}
               disabled={readOnly}
               className={classNames('h-component-navigation-dot-stepper-dot-sizing-size', 'w-component-navigation-dot-stepper-dot-sizing-size', 'rounded-component-navigation-dot-stepper-dot-border-radius', 'appearance-none', {
                  'bg-component-navigation-dot-stepper-dot-color-fill-active-default': currentStep === step && variant === 'default',
                  'bg-component-navigation-dot-stepper-dot-color-fill-active-on-primary': currentStep === step && variant === 'on-primary',
                  'bg-component-navigation-dot-stepper-dot-color-fill-inactive-default': currentStep !== step && variant === 'default',
                  'bg-component-navigation-dot-stepper-dot-color-fill-inactive-on-primary': currentStep !== step && variant === 'on-primary'
               })}
               onClick={() => handleStepChange(step)}
            />
         ))}
      </div>
   );
};
